<template>
  <div>
    <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="formInline.nameOrCode" clearable @keyup.enter.native="onSearch" placeholder="商务供应商名称/编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select filterable v-model="formInline.businessPrincipalId" clearable placeholder="请选择供应商负责人">
          <el-option 
            v-for="(item,index) in businessPrincipalList" 
            :key="index" 
            :label="item.username" 
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div style="padding-bottom:20px;">商务供应商总数：{{total}}条</div>
    <el-table size="small" v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column prop="code" align="center" label="商务供应商编号"></el-table-column>
      <el-table-column prop="name" align="center" label="商务供应商名称"></el-table-column>
      <el-table-column prop="supplierType" align="center" label="供应商类型">
        <template slot-scope="scope">
          <div>{{scope.row.supplierType == 1?"公司":scope.row.supplierType == 2?"个人":""}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="businessPrincipalNames" align="center" label="供应商负责人"></el-table-column>
      <el-table-column prop="editUserName" align="center" label="最新修改人"></el-table-column>
      <el-table-column prop="editTime" align="center" label="最新修改时间"></el-table-column>
      <el-table-column v-if="pageType == 'has'" prop="auditTime" align="center" label="审批时间"></el-table-column>
      <el-table-column prop="auditStatus" align="center" label="审批状态">
        <template slot-scope="scope">
          {{auditStatusList[scope.row.auditStatus]}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button v-if="pageType == 'stay' " type="text" size="small" @click='goUrl(scope.row.id)'>审批</el-button>
          <el-button v-if="pageType == 'has' " type="text" size="small" @click='goUrl(scope.row.id,1)'>重审</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrap">
      <el-pagination background @size-change="sizeChange" @current-change="currentChange"
        :current-page.sync="formInline.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="formInline.pageSize"
        layout="sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { auditProcessSupplierList } from "@/api/approve/business";
import { listAdmin } from "@/api/business/contract";
export default {
  props:['pageType'],
  data() {
    return {
      auditStatusList:['','待直属主管审批','直属主管审批不通过','待业务总监审批','业务总监审批不通过','审批通过' ],
      loading:false,
      total:0,
      formInline: {
        auditFlag:this.pageType == 'stay'?0:1,
        businessPrincipalId:"",
        nameOrCode:"",
        pageNum: 1,
				pageSize: 10,
      },
      tableData: [],
      businessPrincipalList:[],
    };
  },
  watch:{
    pageType(vla){
      this.formInline.auditFlag = vla == 'stay'?0:1,
      this.getList();
    },
  },
  mounted() {
    this.getList();
    listAdmin({
      pageSize: 99999,
      pageNum: 1
    }).then(res=>{
      this.businessPrincipalList = res.data
      console.log('====数据=====',res)
    })
  },
  methods: {
    onSearch(){
      this.getList();
    },
    getList(){
      this.loading = true
      auditProcessSupplierList(this.formInline).then((res) => {
        if(res.code == 1){
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false
          console.log('=====列表数据=====',res)
        }
      }).catch((err) => {
        this.loading = false
      });
    },
    goUrl(id,type){
      let router = this.$router.push({
        path: "/check/businessApproval/assess",
        query: {
          id,
          type
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.formInline.pageNum = 1;
      this.formInline.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.formInline.pageNum = val;
      this.getList();
    },
  },
};
</script>